const e = {
  name: "Resolution",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<path class="st0" d="M40,0v40H0V0H40z M10,38h8V22H2v8h8V38z M2,32v6h6v-6H2z M20,20v18h8V12H2v8H20z M30,38h8V2H2v8h28V38z"/>
</g>
</svg>
  `
};
export {
  e as Resolution
};
